<div class="page">
  <header class="page__header">
    <h1 class="page__title">Settings</h1>
  </header>
  <p-card class="page__content">
    <div class="section">
      <div class="section__title">Notifications</div>
      <form [formGroup]="notificationSettingsGroup">
        <div class="settings__item">
          <i class="pi pi-envelope settings__icon"></i>
          <div class="flex flex-column">
            <span class="settings__title">Mail notifications</span>
            <span class="settings__description">
              Controls whether email notifications are enabled for the system.
            </span>
          </div>
          <div class="ml-auto">
            <p-toggleswitch formControlName="isEmailEnabled" />
          </div>
        </div>
        <div class="settings__item">
          <i class="pi pi-mobile settings__icon"></i>
          <div class="flex flex-column">
            <span class="settings__title">SMS notifications</span>
            <span class="settings__description">
              Controls whether SMS notifications are enabled for the system.
            </span>
          </div>
          <div class="ml-auto">
            <p-toggleswitch formControlName="isSmsEnabled" />
          </div>
        </div>
      </form>
    </div>
    <div class="page__actions">
      <p-button class="page__action--end" label="Save" (click)="save()" />
    </div>
  </p-card>

  @if (showMarketsSettings()) {
  <p-card class="page__content">
    <div class="section">
      <div class="section__title">Markets</div>
      <form [formGroup]="marketsSettingsGroup">
        <div class="settings__item">
          <i class="pi pi-map settings__icon"></i>
          <div class="flex flex-column">
            <span class="settings__title">Operating countries</span>
            <span class="settings__description">
              Select the countries you operate in within the Markets module.
            </span>
          </div>
          <div class="ml-auto">
            <p-multiselect
              formControlName="operatingCountryIds"
              [options]="availableCountries"
              optionLabel="name"
              optionValue="id"
              placeholder="Select countries" />
          </div>
        </div>
      </form>
    </div>
    <div class="page__actions">
      <p-button class="page__action--end" label="Save" (click)="saveMarketsSettings()" />
    </div>
  </p-card>
  }
</div>
